const DRAFT_PREFIX = 'kampboodschappen_draft_';

export function getDraftKey(speltakId) {
  return `${DRAFT_PREFIX}${speltakId || 'unknown'}`;
}

export function hasDraftContent(draft) {
  if (!draft) return false;
  if (draft.leverdatum) return true;
  if (draft.notitie?.trim()) return true;
  if (Array.isArray(draft.vrijeRegels) && draft.vrijeRegels.length > 0) return true;
  return Object.values(draft.quantities || {}).some((qty) => parseInt(qty, 10) > 0);
}

export function loadDraft(speltakId) {
  try {
    const raw = localStorage.getItem(getDraftKey(speltakId));
    if (!raw) return null;
    const draft = JSON.parse(raw);
    return hasDraftContent(draft) ? draft : null;
  } catch {
    return null;
  }
}

export function saveDraft(speltakId, data) {
  const payload = {
    leverdatum: data.leverdatum || '',
    quantities: data.quantities || {},
    vrijeRegels: data.vrijeRegels || [],
    notitie: data.notitie || '',
    savedAt: new Date().toISOString()
  };

  if (!hasDraftContent(payload)) {
    clearDraft(speltakId);
    return null;
  }

  localStorage.setItem(getDraftKey(speltakId), JSON.stringify(payload));
  return payload;
}

export function clearDraft(speltakId) {
  localStorage.removeItem(getDraftKey(speltakId));
}

export function formatDraftSavedAt(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '';

  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
